import React from "react";
import PropTypes from "prop-types";
import { Button, Form, FormGroup } from "reactstrap";

// import { PhoneInput } from "../Shared/Forms/PhoneInput";
import TextInput from "../Shared/Forms/TextInput";
import SelectInput from "../Shared/Forms/SelectInput";
import DatePicker from "../Shared/Forms/DatePicker";
import TextArea from "../Shared/Forms/TextArea";
import {
  requestTypeOptions,
  facilityOptions
} from "./config/formOptionElements";

function formIsValid(userInput) {
  const { name, title, email, type, description } = userInput;

  return (
    name.isValid &&
    title.isValid &&
    email.isValid &&
    type.isValid &&
    description.isValid
  );
}

function RequestForm(props) {
  const {
    handleInputChange,
    handleDateInputChange,
    handleFormSubmit,
    userInput
  } = props;
  const {
    name,
    email,
    phone,
    title,
    type,
    facility,
    due,
    description
  } = userInput;

  return (
    <Form onSubmit={handleFormSubmit} className="container-fluid">
      <TextInput
        stateKey="title"
        labelText="Request Title"
        userInput={title}
        invalidMessage="Please give your request a title"
        onChange={handleInputChange}
      />

      <SelectInput
        stateKey="type"
        labelText="Type"
        userInput={type}
        validate
        invalidMessage="Please choose your request type"
        onChange={handleInputChange}
      >
        {requestTypeOptions}
      </SelectInput>

      <SelectInput
        stateKey="facility"
        labelText="Facility"
        userInput={facility}
        validate
        onChange={handleInputChange}
      >
        {facilityOptions}
      </SelectInput>

      <FormGroup row>
        <label className="col-12">
          Needed By
          <span className="ml-3 text-left small">(Optional)</span>
        </label>
        <DatePicker
          name="due"
          value={due.val}
          onChange={handleDateInputChange}
          showTime={false}
          minimumLeadTime={4}
        />
      </FormGroup>

      <TextArea
        userInput={description}
        labelText="Request Details"
        stateKey="description"
        invalidMessage="Please give us some details about your request"
        rows={6}
        onChange={handleInputChange}
      >
        <p>
          To help fulfill your request, please give lots of details, such as:
        </p>
        <ul>
          <li>Room/office number</li>
          <li>Budget for project</li>
        </ul>
      </TextArea>

      <TextInput
        stateKey="name"
        labelText="Your Name"
        userInput={name}
        invalidMessage="Please enter a valid name"
        onChange={handleInputChange}
      />

      <TextInput
        stateKey="email"
        labelText="Your Email"
        userInput={email}
        invalidMessage="Please enter a valid email address"
        onChange={handleInputChange}
      />

      {/* Changed to TextInput because a file dependency was missing 4-16-2021 */}
      {/* <PhoneInput
        stateKey="phone"
        labelText="Your Phone"
        userInput={phone}
        invalidMessage="Please enter a valid phone number"
        onChange={handleInputChange}
      /> */}

      <TextInput
        stateKey="phone"
        labelText="Your Phone"
        userInput={phone}
        invalidMessage="Please enter a valid phone number. e.g. (XXX) XXX-XXXX"
        onChange={handleInputChange}
      />

      <Button
        disabled={!formIsValid(userInput)}
        color="primary"
        size="lg"
        type="submit"
      >
        Submit
      </Button>
    </Form>
  );
}

RequestForm.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  handleDateInputChange: PropTypes.func.isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
  userInput: PropTypes.object.isRequired
};

export default RequestForm;



// WEBPACK FOOTER //
// ./src/Facilities/RequestForm.js